<script setup lang="ts">
import BaseMediaItemGrid from "@/components/Base/MediaItemGrid.vue";
import StartpageSectionHeadline from "@/components/startpage/SectionHeadline.vue";
import StartpageToolItem from "@/components/startpage/ToolItem.vue";

const { startPageSections } = useTools();
</script>

<template>
  <div v-for="section in startPageSections" :key="section.title" class="mb-6">
    <StartpageSectionHeadline :badge="section.badge">
      {{ section.title }}
    </StartpageSectionHeadline>
    <BaseMediaItemGrid>
      <StartpageToolItem
        v-for="tool in section.tools"
        :key="tool.id"
        :tool="tool"
      />
    </BaseMediaItemGrid>
  </div>
</template>
